module.exports = __webpack_public_path__ + "img/play.79c20773.png";